// import SubscriptionCourse from '../views/SubscriptionCourse';
import VideoCourseView from '../views/VideoCourseView';
import CardCourseView from '../views/CardCourseView';

const router = [
  // {
  //   name: 'subscription-course',
  //   path: '/subscription',
  //   component: SubscriptionCourse,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    name: 'video-course-view',
    path: '/course/video/:courseId',
    component: VideoCourseView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'card-course-view',
    path: '/course/card/:courseId',
    component: CardCourseView,
    meta: {
      requiresAuth: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/course/router/index.js